
import { defineComponent } from "vue";
import Fieldset from "../inputs/Fieldset.vue";
import Number from "../inputs/Number.vue";
import Space from "../global/Space.vue";

export default defineComponent({
  components: {
    Fieldset, Space, Number,
  },
  props: {
    modelValue: { type: Array, required: true },
  },
  emits: [
    "update:modelValue",
  ],
});
